import terraform_outputs from './terraform_outputs.json';

export const config = {
  apiEndpoint: "https://57quhj8lxf.execute-api.us-east-1.amazonaws.com",
  dynamodbTableName: "image-metadata",
  ecrRepositoryUrl: "539241383982.dkr.ecr.us-east-1.amazonaws.com/heyi",
  eventApiEndpoint: "https://t63vzmgd48.execute-api.us-east-1.amazonaws.com/prod",
  s3BucketName: "heyi-bucket",
  sqsQueueUrl: "https://sqs.us-east-1.amazonaws.com/539241383982/image-processing-queue",
  userAuthApiEndpoint: "https://gmb82oz6f2.execute-api.us-east-1.amazonaws.com/prod"
};

export const AUTH_API = terraform_outputs.user_auth_api_endpoint.value;
export const EVENT_API = terraform_outputs.event_api_endpoint.value;
export const FIND_GUEST_API = terraform_outputs.find_guest_images_api_endpoint.value;
export const PROCESS_IMAGES_LB = terraform_outputs.process_images_alb_dns_name.value;
export const PROCESS_IMAGES_LB2 = terraform_outputs.process_images_alb_dns_name.value;
export const UPLOAD_IMAGES_DIRECT = terraform_outputs.upload_http_endpoint.value;

